<div #content class="ck-content" [style.font-family]="obecSettings.paragraph_font" [innerHTML]="data | safeHtml"></div>

